import { ErrorSection } from '@/components/astro/new-design/sections/error-section';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';

type Props = {
  statusCode: number;
};

export function ErrorPage(props: Props) {
  const { statusCode } = props;
  return (
    <div className='relative min-h-screen bg-white text-gray-900'>
      <h1 className='sr-only'>Error {statusCode} - Page Not Found</h1>

      <div className='absolute inset-x-0 top-0 h-[30vh] bg-[linear-gradient(rgba(21,_112,_239,_.2),_rgba(255,_255,_255,_0))]' />
      <NavBar />
      <ErrorSection statusCode={statusCode} />
      <Footer />
    </div>
  );
}
